import Loader from 'components/common/Loader'
import './style.styl'

const LoadingStep = ({ customLoader }) => {
  const CustomLoader = customLoader

  return (
    <div className="loading-step">
      {customLoader ? <CustomLoader /> : <Loader />}
    </div>
  )
}

export default LoadingStep
